/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_RevisionsInputs */

const en_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Included Revisions`)
};

const es_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisiones incluidas`)
};

const fr_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Révisions incluses`)
};

const de_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inklusive Überarbeitungen`)
};

const ja_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含まれる修正回数`)
};

const zh_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含的修改次数`)
};

const ar_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التعديلات المشمولة`)
};

const id_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisi Termasuk`)
};

const it_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisioni Incluse`)
};

const ru_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество правок`)
};

const pt_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisões Incluídas`)
};

const ko_field_revisions = /** @type {(inputs: Field_RevisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수정 제공 횟수`)
};

/**
* | output |
* | --- |
* | "Included Revisions" |
*
* @param {Field_RevisionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_revisions = /** @type {((inputs?: Field_RevisionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_RevisionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_revisions(inputs)
	if (locale === "es") return es_field_revisions(inputs)
	if (locale === "fr") return fr_field_revisions(inputs)
	if (locale === "de") return de_field_revisions(inputs)
	if (locale === "ja") return ja_field_revisions(inputs)
	if (locale === "zh") return zh_field_revisions(inputs)
	if (locale === "ar") return ar_field_revisions(inputs)
	if (locale === "id") return id_field_revisions(inputs)
	if (locale === "it") return it_field_revisions(inputs)
	if (locale === "ru") return ru_field_revisions(inputs)
	if (locale === "pt") return pt_field_revisions(inputs)
	return ko_field_revisions(inputs)
});